module.exports = __webpack_public_path__ + "static/media/przemyslaw-szmigiel.8941ab1a.jpg";